import React from "react";
import PropTypes from "prop-types";
import keygen from "~helpers/keygen";
import styles from "./ribbon.module.scss";

export default function Ribbons({ item, customStyle="" }) {
  if (!item) {
    return null;
  }
  return (
    <div className={`${styles.ribbons || ""} ${customStyle}`}>
      {item &&
        item.map((ribbon) => <span key={keygen}>{ribbon}</span>)}
    </div>
  );
}

Ribbons.propTypes = {
  item: PropTypes.arrayOf(PropTypes.string).isRequired,
  customStyle: PropTypes.string,
};
